import { defineComponent as _defineComponent } from 'vue';
import { onBeforeUnmount, onMounted, ref } from "vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'IntersectionObservable',
    props: {
        observer: null
    },
    setup(__props) {
        const props = __props;
        const element = ref();
        onMounted(() => {
            if (element.value) {
                props.observer.observe(element.value);
            }
        });
        onBeforeUnmount(() => {
            if (element.value) {
                props.observer.unobserve(element.value);
            }
        });
        return { __sfc: true, props, element };
    }
});
